const globalConfig = {
  DEV: {
    url: process.env.REACT_APP_URL
  },
  PRODUCTION: {
    url: process.env.REACT_APP_URL
  }
}
const MODE_CONFIG =
  process.env.REACT_APP_NODE_ENV === 'PRODUCTION' ? 'PRODUCTION' : 'DEV'

export default globalConfig[MODE_CONFIG]
